<div
    *transloco="let t"
    [formGroup]="scheduleForm"
    class="bazis-schedule-control"
>
    @let valueChanges = valueChanges$ | async;
    @let required = required$ | async;

    <div formArrayName="schedule">
        <bazis-grid class="bazis-grid_form bh-margin-bottom-4x">
            <ng-container *ngFor="let scheduleLine of schedule.controls; let i = index">
                <bazis-row
                    [formGroupName]="i"
                    [class.tms-control_no-margin]="
                        scheduleLine.controls.days.valid &&
                        scheduleLine.controls.workingHours.valid &&
                        scheduleLine.controls.restHours.valid &&
                        scheduleLine.invalid
                    "
                >
                    <bazis-col [size]="schedule.controls.length > 1 ? 4 : 5">
                        <app-select-with-tags
                            [id]="anchorRoot ? anchorRoot + '-days-' + i : null"
                            [options]="daysOfWeek"
                            formControlName="days"
                            [required$]="daysRequired$"
                            (touched)="markAsTouched()"
                            titleKey="form.title.schedule.day"
                            placeholderKey="form.placeholder.schedule.selectNoValue"
                            placeholderKeyValue="placeholder.select"
                        ></app-select-with-tags>
                    </bazis-col>
                    <bazis-col>
                        <bazis-input-default
                            [id]="anchorRoot ? anchorRoot + '-workingHours-' + i : null"
                            formControlName="workingHours"
                            [required$]="workingHoursRequired$"
                            [maskSettings]="timeIntervalMaskSettings"
                            titleKey="form.title.schedule.work"
                            placeholderKey="placeholder.default"
                        ></bazis-input-default>
                    </bazis-col>
                    <bazis-col>
                        <bazis-input-default
                            [id]="anchorRoot ? anchorRoot + '-restHours-' + i : null"
                            formControlName="restHours"
                            [maskSettings]="timeIntervalMaskSettings"
                            titleKey="form.title.schedule.restInterval"
                            placeholderKey="placeholder.default"
                        ></bazis-input-default>
                    </bazis-col>
                    @if (schedule.controls.length > 1) {
                        <bazis-col size="auto">
                            <bazis-label isEmptyLabel="true"></bazis-label>
                            <bazis-button
                                color="danger"
                                [disabled]="scheduleForm.disabled"
                                (click)="removeSchedule(i)"
                            >
                                <bazis-icon
                                    slot="icon-only"
                                    name="trash"
                                ></bazis-icon>
                            </bazis-button>
                        </bazis-col>
                    }
                </bazis-row>

                @if (
                    scheduleLine.controls.days.valid &&
                    scheduleLine.controls.workingHours.valid &&
                    scheduleLine.controls.restHours.valid &&
                    scheduleLine.invalid
                ) {
                    <bazis-row class="bh-margin-top-1x bh-margin-bottom-4x">
                        <bazis-col>
                            <div class="bazis-control__error">
                                {{ t('form.error.invalidScheduleRow') }}
                            </div>
                        </bazis-col>
                    </bazis-row>
                }
            </ng-container>
        </bazis-grid>

        @if (schedule.controls.length < 7 && schedule.enabled) {
            <bazis-link
                borderStyle="none"
                size="compact"
                (click)="addScheduleGroup()"
            >
                <bazis-icon
                    slot="end"
                    [name]="icons.plus"
                ></bazis-icon>
                {{ t(addButtonTitleKey) }}
            </bazis-link>
        }
    </div>
</div>
